import React, { useEffect, useState } from "react";
import { Formik, Form, Field } from "formik";
import { BsClipboard, BsPrinterFill } from "react-icons/bs";
import { toastError, toastSuccess } from "../../../../common/Toast";
import { useParams, Link } from "react-router-dom";
import jsPdf from "jspdf";
import Select from "react-select";
import {
  ALREADY_EXIST,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
} from "../../../../common/Constant";
import config from "../../../../config/config";
import axios from "axios";
import Loader from "../../../../components/Loader/Loader";



import { checkUserPermission } from "../../../../common/UserPermission";
let PERMISSION_ALLOWITEMQTYADDSUB = "allowitemqtyaddsub";

const Inventory = (props) => {
  const { Listofdata, callback } = props;
  const buttonRef = React.useRef(null);
  const paramObject = useParams();
  const Id = localStorage.getItem("ID");
  const token = localStorage.getItem("Token");
  const [loading, setLoading] = useState(false);
  const [inventoryValues, setInventoryValues] = useState();
  const [formValues, setFormValues] = useState({
    IReorderLevel: "",
    IReplenishLevel: "",
    DayExpiration: "",
    CurrentQuantity: "",
    DamagedQuantity: 0,
    QtyAddSub: 0,
    InventoryComments: "",
    UpdatedQuantity: 0,
  });

  const [inventroyReport, setInventroyReport] = useState({
    customer: 0,
    supplier: 0,
    inventoryTransaction: 0,
  });
  const [DataForProps, setDataForProps] = useState([]);
  const [SubmitEvent, setSubmitEvent] = useState(0);
  const [custoptions, setCustOptions] = useState([]);
  const [recoptions, setRecOptions] = useState([
    {
      Id: Number,
      CompanyName: String,
      FirstName: String,
      LastName: String,
      Email: String,
      PhoneNumber: Number,
      Address1: String,
      City: String,
      StateProvince: String,
      Zip: Number,
      Country: String,
    },
  ]);
  const [transactiondropdown, setTransactionDropdown] = useState([]);

  const [quantity, setQuantity] = useState('');

  // For parameters-
  let locationId = JSON.parse(localStorage.getItem("Location")) || "";

  const handleBack = () => {
    props.previousStep();
    window.scrollTo(0, 0);
  };
  const handleSubmitForm = () => {
    setSubmitEvent(1);
  };
  const handleVariationInput = (event, index) => {
    let name, values;

    name = event.target.name;
    values = event.target.value;
    console.log("index, name, values", index, name, values);

    if (name == "DamegedQuantity") {
      let cardInput = [...inventoryValues];
      if (cardInput[index]) {
        cardInput[index]["DamegedQuantity"] = values;
        setInventoryValues((prevValues) => {
          const updatedValues = [...prevValues];
          updatedValues[index].DamegedQuantity = Number(values);
          updatedValues[index].UpdatedQuantity =
            Number(updatedValues[index].Quantity) - Number(values);
          updatedValues[index].InventoryAddSubtract = Number(-values);
          return updatedValues;
        });
      }
    } else if (name == "Quantity") {
      let cardInput = [...inventoryValues];
      cardInput[index]["Quantity"] = Number(values);
      cardInput[index]["InventoryAddSubtract"] = parseFloat(values);
      cardInput[index]["DamegedQuantity"] = 0;
      setInventoryValues(cardInput);
    } else if (name == "InventoryAddSubtract") {
      let cardInput = [...inventoryValues];
      cardInput[index]["InventoryAddSubtract"] = parseFloat(values);

      if (parseFloat(values)) {
        setInventoryValues((prevValues) => {
          const updatedValues = [...prevValues];
          updatedValues[index].InventoryAddSubtract = Number(values);
          updatedValues[index].UpdatedQuantity =
            Number(updatedValues[index].Quantity) + Number(values);
          updatedValues[index].DamegedQuantity = 0;
          return updatedValues;
        });
      }
    }
  };

  const ActionButtons = (props) => {
    const handleBack = () => {
      props.previousStep();
      window.scrollTo(0, 0);
    };

    const handleNext = () => {
      props.nextStep();
      window.scrollTo(0, 0);
    };

    return (
      <div className="text-center">
        {props.currentStep > 1 && (
          <button onClick={handleBack} className="btn btn-sm btn-primary me-3">
            Back
          </button>
        )}
        {props.currentStep < props.totalSteps && (
          <button onClick={handleNext} className="btn btn-sm btn-primary">
            Next
          </button>
        )}
      </div>
    );
  };
  function handleButtonClick() {
    buttonRef.current.click();
  }

  // handleInput-
  const handleInput = (e) => {
    const { name, value } = e.target;
    console.log("handleInput 124", name, value);
    if (name === "DamagedQuantity") {
      console.log(
        "formValues.DamagedQuantity",
        formValues.CurrentQuantity,
        value,
        Number(formValues.CurrentQuantity) - Number(value)
      );
      setFormValues({
        ...formValues,
        UpdatedQuantity: Number(formValues.CurrentQuantity) - Number(value),
        DamagedQuantity: Number(value),
        QtyAddSub: -Number(value),
      });
    } else if (name === "QtyAddSub") {
      if (checkUserPermission(PERMISSION_ALLOWITEMQTYADDSUB)) {
        setQuantity(value);
        setFormValues({
          ...formValues,
          UpdatedQuantity: Number(formValues.CurrentQuantity) + Number(value),
          QtyAddSub: Number(value),
          DamagedQuantity: 0,
        });
      }
      else {
        if (value >= 0) {
          setQuantity(value);
          setFormValues({
            ...formValues,
            UpdatedQuantity: Number(formValues.CurrentQuantity) + Number(value),
            QtyAddSub: Number(value),
            DamagedQuantity: 0,
          });

        }
      }


    }
  };

  // handlesubmit-
  const handleSubmit = (values) => {
    let VariationData = inventoryValues?.map((el) => {
      return {
        ...el,
        Quantity: el.UpdatedQuantity,
        DamegedQuantity: +el.DamegedQuantity,
      };
    });
    console.log("VariationData 125", VariationData);

    VariationData = VariationData?.filter(function (variationValue) {
      return variationValue.ItemVariationId !== "";
    });

    console.log("VariationData 135", VariationData);

    const inventoryobj = {};
    const variationpricingobj = {};

    inventoryobj.InventoryItemDataXML = [values];
    variationpricingobj.InventoryItemVariationDataXML = VariationData;

    let inventoryjsonstring = JSON.stringify(inventoryobj);
    let variationpricingjsonstring = JSON.stringify(variationpricingobj);

    setLoading(true);
    axios
      .post(
        `${config.itemsBaseUrl}/items/inventoryupsert`,
        {
          itemid: paramObject.id || 0,
          reorderlevel: values.IReorderLevel,
          replenishlevel: values.IReplenishLevel,
          daystoexpiration: values.DayExpiration,
          qtyaddsub: values.QtyAddSub,
          inventorycomments: values.InventoryComments,
          xmlvariation: variationpricingjsonstring,
          loginuserid: Id,
          locationid: locationId,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setLoading(false);
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess(SUCCESS_MESSAGE);
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError("Name" + ALREADY_EXIST);
        } else {
          toastError(ERROR_MESSAGE);
        }
        axios
          .get(
            `${config.itemsBaseUrl}/items/itemsrackselectbyid?ItemId=${paramObject.id}`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            setLoading(false);
            setDataForProps(res.data.ResponseData);
            callback(res.data.ResponseData);

            if (SubmitEvent == 1) {
              setSubmitEvent(0);
            } else {
              props.nextStep();
              window.scrollTo(0, 0);
            }
          })
          .catch((err) => {
            console.log("error: " + err);
          });
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log("error: ", error);
      });
  };

  // Dropdowns
  const customerDropDown = custoptions.map((option) => ({
    value: option.Id,
    label: option.CompanyName + "(" + option.FirstName + " " + option.LastName + ")",
    address: option.Address1,
    email: option.Email,
  }));

  const supplierDropDown = recoptions.map((option) => ({
    value: option.ID,
    label: option.CompanyName + "(" + option.FirstName + " " + option.LastName + ")", // option.FirstName + " " + option.LastName,
    address: option.Address,
  }));

  const inventorydropdown = transactiondropdown.map((option) => ({
    value: option.ID,
    label: option.Type,
  }));

  const handleChangeCustomer = (e) => {
    setInventroyReport({ ...inventroyReport, customer: e.value });
  };

  const handleChangeSupplier = (e) => {
    setInventroyReport({ ...inventroyReport, supplier: e.value });
  };

  const handleChangeInventoryTransaction = (e) => {
    setInventroyReport({ ...inventroyReport, inventoryTransaction: e.value });
  };

  const [itemsInventory, setItemsInventory] = useState([]);

  useEffect(() => {
    setLoading(true);
    axios
      .get(
        `${config.itemsBaseUrl}/items/inventoryfindbyid?id=${paramObject.id}&locationid=${locationId}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setLoading(false);
        console.log(
          "res.data.ResponseData.Itemsvariations 229",
          res.data.ResponseData.Itemsvariations
        );
        setInventoryValues(res.data.ResponseData.Itemsvariations);

        const bindingData = {
          IReorderLevel:
            parseFloat(res.data.ResponseData.Items[0].Reorderlevel) > 0
              ? parseFloat(res.data.ResponseData.Items[0].Reorderlevel)
              : 0,
          IReplenishLevel:
            parseFloat(res.data.ResponseData.Items[0].Replenishlevel) > 0
              ? parseFloat(res.data.ResponseData.Items[0].Replenishlevel)
              : 0,
          DayExpiration:
            parseFloat(res.data.ResponseData.Items[0].Expiredays) > 0
              ? parseFloat(res.data.ResponseData.Items[0].Expiredays)
              : 0,
          CurrentQuantity:
            parseFloat(res.data.ResponseData?.Items[0]?.Defaultquantity) > 0
              ? parseFloat(res.data.ResponseData?.Items[0]?.Defaultquantity)
              : 0,
          DamagedQuantity: "",
          QtyAddSub: "",
          InventoryComments: res.data.ResponseData?.Itemsinventory[0]?.Comment,
        };

        console.log(
          "res.data.ResponseData?.Itemsinventory[0]?.Comment",
          res.data.ResponseData?.Itemsinventory[0]?.Comment
        );
        setFormValues(bindingData);
      })
      .catch((err) => {
        setLoading(false);
        console.log("err: ", err);
      });

    axios
      .get(
        `${config.itemsBaseUrl}/items/inventoryquantitylisting?ItemID=${paramObject.id}&Locationid=${locationId}&SupplierId=${inventroyReport.supplier}&CustomerId=${inventroyReport.customer}&TransactionType=${inventroyReport.inventoryTransaction}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setLoading(false);
        setItemsInventory(res.data.ResponseData);
      })
      .catch((err) => {
        setLoading(false);
        console.log("err: ", err);
      });
  }, [props, inventroyReport]);

  useEffect(() => {
    axios
      .get(`${config.customersBaseUrl}/customers/customerdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        setCustOptions(response.data.ResponseData);
        console.log(response.data.ResponseData, "===> setCustOptions");
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get(`${config.generalBaseUrl}/generals/supplierdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        console.log("supplyer list", response.data.ResponseData);
        setRecOptions(response.data.ResponseData);
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get(`${config.itemsBaseUrl}/items/inventorytransaction`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        console.log("supplyer list", response.data.ResponseData);
        setTransactionDropdown(response.data.ResponseData);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  // Print Report-
  const handleDownload = () => {
    setLoading(true);
    var doc = new jsPdf("p", "pt", "a4");

    let content = "";
    let startIndex = 1;
    let endIndex = 30;

    for (var i = 1; i <= Math.ceil(itemsInventory.length / 30); i++) {
      if (i == 1) {
        content +=
          '<div style="width: 580px; margin-top: 1rem; margin-right: 1rem; text-align: right; font-size: 7px; font-weight: bold">Page' +
          i +
          "/" +
          Math.ceil(itemsInventory.length / 30) +
          "</div>";
      } else {
        content +=
          '<div style="width: 580px; margin-top: 2.4rem; margin-right: 1rem; text-align: right; font-size: 7px; font-weight: bold">Page' +
          i +
          "/" +
          Math.ceil(itemsInventory.length / 30) +
          "</div>";
      }

      content +=
        '<div style="width: 580px; margin-right: 1rem; margin-left: 1rem; margin-top: 0rem; margin-bottom: 0rem"><p style="font-weight: bold; font-size: 7px">Reports - RLD Detailed Inventory Report Detailed Inventory Report - 01/01/2023-12/31/2023 - 1 results found, Generation Date 08/05/2023 01:54 am ' +
        "<p></div>";

      // Printing table body-
      content +=
        '<table style="font-size: 7px; margin: 1rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 8px;">Sr No.</th>' +
        '<th style="padding: 8px;">Inventory Data Tracking</th>' +
        '<th style="padding: 8px; width: 300px">Variation</th>' +
        '<th style="padding: 8px;">In / Out Qty</th>' +
        '<th style="padding: 8px;">	Type</th>' +
        "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex-
      for (let index = startIndex; index <= endIndex; index++) {
        if (index >= startIndex && index <= itemsInventory.length) {
          content +=
            "<tr>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            index +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            // new Date(
            //   itemsInventory[index - 1].InvoiceDate
            // ).toLocaleDateString() +
            new Date(
              itemsInventory[index - 1].TransactionDate
            ).toLocaleDateString() +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            itemsInventory[index - 1].Name +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            Number(itemsInventory[index - 1].InventoryAddSubtraction).toFixed(2) +
            // Number(itemsInventory[index - 1].Quantitypurchased).toFixed(2) +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            itemsInventory[index - 1].TransactionType +
            // itemsInventory[index - 1].Type +
            "</td>" +
            "</tr>";
        }

        if (index % 30 == 0) {
          startIndex = startIndex + 30;
          endIndex = endIndex + 30;
          break;
        }
      }

      content += "</tbody>";
      content += "</table>";
    }

    // Printing page-
    doc.html(content, {
      callback: function (pdf) {
        pdf.save(`pdf.pdf`);
        setLoading(false);
      },
    });
  };

  return (
    <>
      <Loader loading={loading} />
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center p-2">
          <h5 className="card-title">
            <BsClipboard className="me-1" />
            Inventory (Fields in red are required)
          </h5>
          <div>
            {props.currentStep > 1 && (
              <button
                onClick={handleBack}
                className="btn btn-sm btn-primary btn-md me-1"
              >
                Back
              </button>
            )}
            {props.currentStep < props.totalSteps && (
              <button
                //onClick={handleNext}
                className="btn btn-sm btn-primary btn-md"
                type="button"
                onClick={handleButtonClick}
              >
                Next
              </button>
            )}
          </div>
        </div>

        <div className="card-body p-1">
          {" "}
          <Formik
            {...props}
            initialValues={formValues}
            // validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize
          >
            {({ errors, touched, handleChange }) => (
              <Form className="row">
                <div className="col-md-2 mb-1 align-center">
                  <label className="form-label">Reorder Level</label>
                </div>
                <div className="col-md-1 mb-1 mt-1">
                  <Field
                    type="text"
                    className="form-control form-control-sm"
                    id="IReorderLevel"
                    name="IReorderLevel"
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-2 mb-1 align-center">
                  <label className="form-label">Replenish Level</label>
                </div>
                <div className="col-md-1 mb-1 mt-1">
                  <Field
                    type="text"
                    className="form-control form-control-sm"
                    id="IReplenishLevel"
                    name="IReplenishLevel"
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-2 mb-1 align-center">
                  <label className="form-label">Days To Expiration</label>
                </div>
                <div className="col-md-1 mb-1 mt-1">
                  <Field
                    type="text"
                    className="form-control form-control-sm"
                    id="DayExpiration"
                    name="DayExpiration"
                    onChange={handleChange}
                  />
                </div>

                {/* For hide and show */}
                {inventoryValues?.length <= 0 && (
                  <>
                    <div className="col-md-2 mb-3 align-center">
                      <label className="form-label">Current Quantity</label>
                    </div>
                    <div className="col-md-1 mb-3">
                      <Field
                        type="number"
                        className="form-control form-control-sm"
                        id="CurrentQuantity"
                        name="CurrentQuantity"
                        onChange={handleChange}
                        onInput={(e) => handleInput(e)}
                        // value={formValues?.UpdatedQuantity || formValues?.CurrentQuantity}
                        value={
                          !formValues?.UpdatedQuantity &&
                            formValues?.UpdatedQuantity !== 0
                            ? formValues?.CurrentQuantity
                            : formValues?.UpdatedQuantity
                        }
                        disabled
                      />
                    </div>
                    <div className="col-md-6 mb-3 mt-3">
                      <label className="form-label me-5 mx-4">
                        Suspended Inventory:{" "}
                      </label>
                      Not Set
                    </div>
                    <div className="col-md-2 mb-3 mt-3 align-center">
                      <label className="form-label">Damaged Qty</label>
                    </div>
                    <div className="col-md-4 mb-3 mt-2">
                      <Field
                        type="number"
                        className="form-control form-control-sm"
                        id="DamagedQuantity"
                        name="DamagedQuantity"
                        onChange={handleChange}
                        onInput={(e) => handleInput(e)}
                      />
                    </div>
                    <div className="col-md-2 mb-3 align-center">
                      <label className="form-label">
                        Inventory To Add/Subtract
                      </label>
                    </div>
                    <div className="col-md-4 mb-3 mt-4">
                      {/* <Field
                        type="number"
                        className="form-control form-control-sm"
                        id="QtyAddSub"
                        name="QtyAddSub"
                        onChange={handleChange}
                        onInput={(e) => handleInput(e)}
                      /> */}

                      {checkUserPermission(PERMISSION_ALLOWITEMQTYADDSUB) ? (
                        <Field
                          type="number"
                          className="form-control form-control-sm"
                          id="QtyAddSub"
                          name="QtyAddSub"
                          onChange={handleChange}
                          onInput={(e) => handleInput(e)}
                          value={quantity}
                        />
                      ) : (
                        <Field
                          type="number"
                          className="form-control form-control-sm"
                          id="QtyAddSub"
                          name="QtyAddSub"
                          onChange={handleChange}
                          onInput={(e) => handleInput(e)}
                          min="0"
                          value={quantity}
                        />
                      )}
                    </div>
                    <div className="col-md-2 mb-3 align-center">
                      <label className="form-label">Comments</label>
                    </div>
                    <div className="col-md-4 mb-3 mt-2">
                      <textarea
                        name="InventoryComments"
                        cols="17"
                        rows="3"
                        id="InventoryComments"
                        className="form-control form-control-sm text-area"
                        defaultValue={formValues.InventoryComments}
                        onChange={handleChange}
                      ></textarea>
                    </div>
                  </>
                )}

                {/* Variation for the particular Item Id */}
                {inventoryValues?.length > 0 === true && (
                  <>
                    <h5 className="form-check-label mt-1 mb-1 fw-bold">
                      Item Variations:
                    </h5>
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>Supplier</th>
                            <th>Name</th>
                            <th>Item Attributes</th>
                            <th>Item Number</th>
                            <th>Reorder Level</th>
                            <th>Replenish Level</th>
                            {/* <th>Quantity</th> */}
                            <th>Quantity</th>
                            <th>Damaged Qty</th>
                            <th>Damaged Reason</th>
                            <th>Inventory to (+/-)</th>
                            <th>Comments</th>
                          </tr>
                        </thead>

                        <tbody>
                          {inventoryValues?.map((u, variationIndex) => (
                            <tr key={variationIndex}>
                              <td>{u.SupplierName}</td>
                              <td>{u.VariationName}</td>
                              <td>{u.AttributeName}</td>
                              <td>{u.ItemNumber}</td>
                              {/* Reorder Level */}
                              <td>
                                <Field
                                  type="number"
                                  className="form-control form-control-sm"
                                  id={`VariationReorderLevel-${variationIndex}`}
                                  name={`ReorderLevel`}
                                  value={parseFloat(u.ReorderLevel)}
                                  onChange={(event) => {
                                    handleVariationInput(event, variationIndex);
                                  }}
                                />
                              </td>

                              {/* Replenish Level */}
                              <td>
                                <Field
                                  type="number"
                                  className="form-control form-control-sm"
                                  id={`VariationReplenishLevel-${variationIndex}`}
                                  name={`ReplenishLevel`}
                                  value={parseFloat(u.ReplenishLevel)}
                                  onChange={(event) => {
                                    handleVariationInput(event, variationIndex);
                                  }}
                                />
                              </td>

                              {/* Quantity */}
                              {/* <td>
                                <Field
                                  type="number"
                                  className="form-control"
                                  id={`VariationQuantity-${variationIndex}`}
                                  name={`Quantity`}
                                  defaultvalue={parseFloat(u.Quantity)}
                                  value={parseFloat(u.Quantity)}
                                  disabled
                                  onChange={(event) => {
                                    handleVariationInput(event, variationIndex);
                                  }}
                                />
                              </td> */}

                              {/* In Real Updated Quantity But we are using as Quantity */}
                              <td>
                                <Field
                                  style={{ width: "100px" }}
                                  type="number"
                                  className="form-control form-control-sm"
                                  id={`VariationQuantity-${variationIndex}`}
                                  name={`UpdatedQuantity`}
                                  // defaultvalue={parseFloat(u.UpdatedQuantity)}
                                  value={
                                    !parseFloat(u.UpdatedQuantity) &&
                                      parseFloat(u.UpdatedQuantity) !== 0
                                      ? parseFloat(u.Quantity)
                                      : parseFloat(u.UpdatedQuantity)
                                  }
                                  disabled
                                  onChange={(event) => {
                                    handleVariationInput(event, variationIndex);
                                  }}
                                />
                              </td>

                              {/* Damaged Quantity */}
                              <td>
                                <Field
                                  type="number"
                                  className="form-control form-control-sm"
                                  id={`DamegedQuantity-${variationIndex}`}
                                  name={`DamegedQuantity`}
                                  value={
                                    parseFloat(u.DamegedQuantity) === 0
                                      ? ""
                                      : parseFloat(u.DamegedQuantity)
                                  }
                                  onChange={(event) => {
                                    handleVariationInput(event, variationIndex);
                                  }}
                                />
                              </td>

                              {/* Damaged Reason */}
                              <td>
                                <Field
                                  type="text"
                                  className="form-control form-control-sm"
                                  id={`DamagedReason-${variationIndex}`}
                                  name={`DamagedReason`}
                                  // value={u.DamagedReason}
                                  onChange={(event) => {
                                    handleVariationInput(event, variationIndex);
                                  }}
                                />
                              </td>

                              {/* Inventory to add/subtract */}
                              <td>
                                <Field
                                  type="number"
                                  className="form-control form-control-sm"
                                  id={`InventoryAddSubtract-${variationIndex}`}
                                  name={`InventoryAddSubtract`}
                                  value={
                                    parseFloat(u.InventoryAddSubtract) === 0
                                      ? ""
                                      : parseFloat(u.InventoryAddSubtract)
                                  }
                                  onChange={(event) => {
                                    handleVariationInput(event, variationIndex);
                                  }}
                                />
                              </td>

                              {/* Comments */}
                              <td>
                                <Field
                                  type="text"
                                  className="form-control form-control-sm"
                                  id={`Comments-${variationIndex}`}
                                  name={`Comments`}
                                  // value={u.Comments}
                                  onChange={(event) => {
                                    handleVariationInput(event, variationIndex);
                                  }}
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}

                {/* Next and Back Button */}
                <div className="text-center mb-4 mt-4">
                  {props.currentStep > 1 && (
                    <button
                      type="button"
                      onClick={handleBack}
                      className="btn btn-sm btn-primary me-3"
                    >
                      Back
                    </button>
                  )}
                  {props.currentStep < props.totalSteps && (
                    <button
                      type="submit"
                      className="btn btn-sm btn-primary me-3"
                      ref={buttonRef}
                    >
                      Next
                    </button>
                  )}
                  <button
                    onClick={handleSubmitForm}
                    className="btn btn-sm btn-primary btn-md me-3"
                    id="btn_submit"
                    type="submit"
                  >
                    Save
                  </button>
                  <Link to="/items" className="btn btn-sm btn-secondary btn-md">
                    Cancel
                  </Link>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>

      {/* Report */}
      <div className="card">
        <div className="card-body">
          {/* <div className="row">
            <div className="col-md-4 mb-3 mt-5">
              <button type="button" className="btn btn-primary">
                View Report [Last 7 Days]
              </button>
            </div>
            <div className="col-md-4 mb-3 mt-5">
              <button type="button" className="btn btn-primary ">
                View Report [Last 30 Days]
              </button>
            </div>
            <div className="col-md-4 mb-3 mt-5">
              <button type="button" className="btn btn-primary ">
                View Report [This Year]
              </button>
            </div>
          </div> */}
          <div className="row">
            <div className="col-md-4 mb-3 mt-5">
              Customer:
              <Select
                // defaultValue={customerValue}
                onChange={(event) => {
                  handleChangeCustomer(event);
                }}
                options={customerDropDown}
                backspaceRemovesValue={false}
                controlShouldRenderValue={true}
                isClearable={true}
                className="custom-search-select"
              />
            </div>
            {/* inventorytransaction */}
            <div className="col-md-4 mb-3 mt-5">
              Supplier:
              <Select
                // defaultValue={supplierValue}
                onChange={(event) => {
                  handleChangeSupplier(event);
                }}
                options={supplierDropDown}
                backspaceRemovesValue={false}
                controlShouldRenderValue={true}
                isClearable={true}
                className="custom-search-select"
              />
            </div>
            {/* inventorytransaction */}
            <div className="col-md-4 mb-3 mt-5">
              Transaction:
              <Select
                // defaultValue={supplierValue}
                onChange={(event) => {
                  handleChangeInventoryTransaction(event);
                }}
                options={inventorydropdown}
                backspaceRemovesValue={false}
                controlShouldRenderValue={true}
                isClearable={true}
                className="custom-search-select"
              />
            </div>
          </div>
          <div className="col-md-12 mb-3 mt-3">
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Item Variation</th>
                    <th style={{ textAlign: "right" }}>In/Out Qty</th>
                    <th style={{ textAlign: "right" }}>Quantity Onhand</th>
                    <th style={{ textAlign: "right" }}>Balance</th>
                    <th>Type</th>
                    <th>Reference</th>
                    {/* <th>Supplier/Customer</th> */}
                  </tr>
                </thead>
                <tbody>
                  {itemsInventory.length > 0 ? (
                    itemsInventory.map((item, index) => (
                      <tr key={index}>
                        <td>
                          {new Date(item.TransactionDate).toLocaleDateString()}
                        </td>
                        <td>{item?.Name}</td>
                        <td style={{ textAlign: "right" }}>
                          {Number(item?.InventoryAddSubtraction).toFixed(2)}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {Number(item?.PastQuanitity).toFixed(2)}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {Number(item?.CurrentQuantity).toFixed(2)}
                        </td>
                        <td> {item?.TransactionType}</td>
                        <td> {item?.RefrenceNo}</td>
                        {/* <td> {item?.CompanyName}</td> */}
                      </tr>
                    ))
                  ) : (
                    <tr style={{ textAlign: "center", columnSpan: 6 }}>
                      <td>No Data</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-12 align-center mb-2 mt-1">
        <button className="btn btn-sm btn-secondary" onClick={handleDownload}>
          <BsPrinterFill className="me-1" />
          Print
        </button>
      </div>
    </>
  );
};

export default Inventory;
